import { SafeUrl, SafeHtml } from '@angular/platform-browser';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';

export interface ITabs {
  tabId?: string;
  name: string;
  hasViewerButtons?: boolean;
  showSignButton?: boolean;
  showPrintButton?: boolean;
  showPlaceInRegDoc?: boolean;
  ViewerContentType: ViewerContentType;
  contentUrl?: SafeUrl;
  viewerToken?: string;
  hasContentUrl?: boolean;
  htmlContent?: string;
  hashHtmlContent?: boolean;
  updateCallbackfunction?: Function;
  PersonAssetId?: number;
  PersonAssetGuid?: string;
  AssetId: number;
  SusarAssetStatusId?: number;
  DocumentType?: DocumentType;
  DocumentPath?: string;
  SusarDILID?: number;
  DILStorageID?: string;
  StatusUpdatePromise?: Observable<any>;
  IsFormSubmitted?: boolean;
  SRGridList?:any[];
  HasMultipleAssignment?: string;
  SiteId?: number;
  EnableAIInsights?: boolean;
}

export enum ViewerContentType {
  Document = 1,
  ScormPlayer = 2,
  HtmlContent = 3,
  Video = 4
}
export interface IRegDocSites {
  SiteGuid: string;
  SiteName: string;
  BinderGuid: string;
  BinderName: string;
}
export interface IERegDoc {
  SiteGuid: string;
  BinderGuid: string;
}
export enum UserRoles {
  ProjectTeam = "Project Team",
  SiteUser = "Site Users"

}
export enum DocumentType {
  Certificate = "Certificate",
  AllCertificate = "AllCertificate",
  Training = "Training",
  Document = "Document",
  SafetyReport = "SafetyReport",
  SafetyReportDIL = "SafetyReportDIL",
  Survey = "Survey",
  Others = "Others",
  TeamDocument = "TeamDocuments"
}
export interface IPlaceIneRegBinder {
  eRegDoc: IERegDoc;
  Title: string;
  HtmlText: string;
  PlaceSameFile: boolean;
  DocumentType: DocumentType;
  DocumentPath: string;
  AssetId: number;
  PersonAssetGuid: string;
  ViewingSessionId: string;
  SiteId?: number;
}
export interface ICopyDocumentReponse {
  Exception: string;
  InnerMessage: string;
  Message: string;
  Status: string; // "duplicate , .....";
  SuccessFlag: boolean
  Type: string;
}

export interface IAssetStatus {
  AssetId: number;
  AssetName: string;
  DatePosted: string;
  DateDue: string;
  Status: string;
  DateCompleted: string;
  DateSigned: string;
  PersonAssetID: number;
  PersonAssetGUID: string;
  AssetIsActive: number;
}

export interface IViewerParams {
  DocumentUrl: string;
  ViewingSessionId: string;
  DownloadCallbackFunction: string;
  DownloadCallbackFunctionParam: string;
  Anontation?: boolean;
  Download?: boolean;
  Print?: boolean;
  PageNumber?: number;
  SearchText?: string;
  Score?: string;
  CitationBoundary?:string;
  EnableAIInsights?: boolean;
}
